
namespace TabAurous.Reports {
    import fld = OMS.LedgerPostingRow;
    @Serenity.Decorators.registerClass()
    export class BalanceSheetGrid extends Serenity.EntityGrid<TabAurous.OMS.LedgerPostingRow, any> {
        protected getColumnsKey() { return 'OMS.BalanceSheet'; }
        protected getDialogType() { return TabAurous.OMS.LedgerPostingDialog; }
        protected getIdProperty() { return TabAurous.OMS.LedgerPostingRow.idProperty; }
        protected getInsertPermission() { return TabAurous.OMS.LedgerPostingRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.OMS.LedgerPostingRow.localTextPrefix; }
        protected getService() { return TabAurous.OMS.BalanceSheetService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            //    this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            var currencyformat = Intl.NumberFormat('en-US');
            Q.first(columns, x => x.field === fld.Fields.Amount1).format = ctx => {
                if (ctx.item.Amount1 != null)
                return "<p style='text-align: right; color:black;' >" + currencyformat.format(ctx.item.Amount1) + "</p>";
            }
            Q.first(columns, x => x.field === fld.Fields.Amount2).format = ctx => {
                if (ctx.item.Amount2 != null)
                    return "<p style='text-align: right; color:black;' >" + currencyformat.format(ctx.item.Amount2) + "</p>";
            }
            Q.first(columns, x => x.field === fld.Fields.Balance).format = ctx => {
                if (ctx.item.LedgerName == "Asset Total")
                    return "<p style='text-align: right; color:green;' >" + currencyformat.format(ctx.item.Balance) + "</p>";
                if (ctx.item.LedgerName == "Liabilities Total")
                    return "<p style='text-align: right; color:red;' >" + currencyformat.format(ctx.item.Balance) + "</p>";
                if (ctx.item.LedgerName == "Total Balance")
                    return "<p style='text-align: right; color:blue;' >" + currencyformat.format(ctx.item.Balance) + "</p>";
            }
            Q.first(columns, x => x.field === fld.Fields.LedgerName).format = ctx => {
                if (ctx.item.LedgerName == "Asset Total")
                    return "<p style='text-align: center; color:green;font-weight:bold;' >" + ctx.item.LedgerName + "</p>";
                if (ctx.item.LedgerName == "Liabilities Total")
                    return "<p style='text-align: center; color:red;font-weight:bold;' >" + ctx.item.LedgerName + "</p>";
                if (ctx.item.LedgerName == "Total Balance")
                    return "<p style='text-align: center; color:blue;font-weight:bold;' >" + ctx.item.LedgerName + "</p>";
                return "<p style='color:black;' >" + ctx.item.LedgerName + "</p>";
            }
            return columns;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            //let x;
            //OMS.LedgerPostingService.BalanceSheetList({},
            //    response =>
            //        x = response,
            //    { async: false });

            //let check = false;
            //for (let item of x.Entities) {
            //    item[this.getIdProperty()] = item.LedgerPostingId;
            //    check = true;
            //    this.view.addItem(item);
            //}
            ////grid.setData(x1, true);
            ////var c = grid.getData();
            //if (!check) {
            //    this.view.setItems([], true);
            //}



            //this.view.setGrouping([{


            //    formatter: g => {
            //        if (g.totals.sum.Amount1 > 0)
            //            return "<span class='slick-group-title-header'>" +
            //                g.value + " <span style='font-weight: bold;text-align: right;float:right;'>" +
            //                g.totals.sum.Amount1.toFixed(2) + "</span></span>";
            //        else
            //            return "<span class='slick-group-title-header'>" +
            //                g.value + " <span style='font-weight: bold; color: red;text-align: right;float:right;'>(" +
            //                Math.abs(g.totals.sum.Amount2.toFixed(2)) + ")</span></span>";

            //    },
            //    getter: 'Nature',
            //    displayTotalsRow: false,
            //    aggregators: [
            //        new Slick.Aggregators.Sum('Balance')
            //    ]
            //},

            //{

            //    formatter: g => {

            //        if (g.totals.sum.Amount2 > 0)
            //            return "<span class='slick-group-title-header'>" +
            //                g.value + " <span style='font-weight: bold;text-align: right;float:right;'>" +
            //                g.totals.sum.Amount2.toFixed(2) + "</span></span>";
            //        else
            //            return "<span class='slick-group-title-header'>" +
            //                g.value + " <span style='font-weight: bold; color: red;text-align: right;float:right;'>(" +
            //                Math.abs(g.totals.sum.Amount2.toFixed(2)) + ")</span></span>";
            //    },
            //    getter: 'Liabilities',
            //    aggregators: [
            //        new Slick.Aggregators.Sum('Balance')
            //    ],
            //    displayTotalsRow: false

            //}])

            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = false;
            return opt;
        }


        protected usePager() { return false; };
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: 'Finance.BalanceSheet',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            }
            );
            return buttons;
        }
    }
}